import Konva from "konva";

export default class SlidableGroup extends Konva.Group {
  setLeft: (this: SlidableGroup) => void = () => {};
  setCenter: (this: SlidableGroup) => void = () => {};
}
